import type { Descendant } from 'platejs';
import { ElementApi, TextApi } from 'platejs';
import type { PlateEditor } from 'platejs/react';

import { getIsEditorWithMarkdownApi } from '../../ChatEditor';

/**
 * Serialize editor content to markdown.
 *
 * Plate's `preserveEmptyParagraphs` keeps blank lines via `\u200B`, but spreads leftover marks onto
 * that marker (`{ ...child, text: '\u200B' }`) so a blank line after bold becomes `****`. Strip
 * marks from empty text first so the marker stays unadorned.
 */
export function getEditorMarkdown(editor: PlateEditor): string {
  if (!getIsEditorWithMarkdownApi(editor)) {
    console.error('Editor is not a markdown editor.');
    return '';
  }

  return editor.api.markdown.serialize({
    preserveEmptyParagraphs: true,
    value: stripMarksFromEmptyText(editor.children),
  });
}

function stripMarksFromEmptyText(nodes: Descendant[]): Descendant[] {
  return nodes.map(node => {
    if (TextApi.isText(node)) return node.text === '' ? { text: '' } : node;
    if (!ElementApi.isElement(node)) return node;
    return { ...node, children: stripMarksFromEmptyText(node.children) };
  });
}
